export const UPDATE_MFA_DIALOG_CONSTANTS = {
    EMAIL_MFA_ID: 'Email',
    AUTHENTICATOR_MFA_ID: 'Authenticator',
    ADD_METHOD_FLAG: 'add',
    REMOVE_METHOD_FLAG: 'remove',
};

export default UPDATE_MFA_DIALOG_CONSTANTS;
